import { Label, Radio } from "flowbite-react";

import { useHubspot } from "../../../../contexts";
import { PipelineRoleCard } from "./PipelineRoleCard";
import { useVisibleRoles } from "./pipelineRoles";

export const REVENUE_TYPES = [
  { value: "month", label: "Month (MRR)" },
  { value: "year", label: "Year (ARR)" },
];

// Step 1 of the setup: deal revenue type plus one collapsible card per
// pipeline role (active, pilot, churned, renewal, upsell).
export const HsPipelinesStep = () => {
  const { pipelines, hubspotCustomizations, updateHsCustomizations } =
    useHubspot();
  const visibleRoles = useVisibleRoles();

  return (
    <div className="flex flex-col gap-3">
      <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
        <p className="font-semibold text-black">Deal Revenue Type</p>
        <p className="text-xs text-gray-500">
          Are your deal amounts per month or per year?
        </p>
        <div className="mt-3 flex flex-row gap-6">
          {REVENUE_TYPES.map(({ value, label }) => (
            <div key={value} className="flex items-center gap-2">
              <Radio
                id={`deal-revenue-${value}`}
                name="deal-revenue-type"
                value={value}
                checked={hubspotCustomizations?.deal_revenue_type === value}
                onChange={(e) =>
                  updateHsCustomizations({ deal_revenue_type: e.target.value })
                }
              />
              <Label htmlFor={`deal-revenue-${value}`}>{label}</Label>
            </div>
          ))}
        </div>
      </div>

      {visibleRoles.map((role) => (
        <PipelineRoleCard
          key={role.key}
          role={role}
          pipelines={pipelines}
          customizations={hubspotCustomizations}
          onUpdate={updateHsCustomizations}
          activeDealPipelineId={
            hubspotCustomizations?.active_deal_pipeline?.id || ""
          }
        />
      ))}
    </div>
  );
};
